<!--
 * @Date: 2020-05-19 10:32:35
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-28 15:18:08
 * @FilePath: /xy-pc/src/views/homelayout/roomclass/confirmOrder.vue
--> 

<template>
  <div class="container" style="padding:20px;min-height:70vh">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/roomclass' }">班级课程</el-breadcrumb-item>
      <el-breadcrumb-item>确认订单</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding:10px"></div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-image style="width: 100%; height: 226px" :src="goodsInfo.thumb_image" fit="cover"></el-image>
      </el-col>
      <el-col :span="12">
        <p class="goodsTit">{{goodsInfo.name}}</p>
        <div class="priceInfo">
          <div class="infoItem">
            <span class="title">时间：</span>
            <span class="content">{{goodsInfo.begin_at}}～ {{goodsInfo.end_at}}</span>
            <el-rate :value="goodsInfo.score-0" disabled :colors="['#33b17b','#33b17b','#33b17b']"></el-rate>
          </div>
          <div class="infoItem">
            <span class="title">岗位：</span>
            <span class="content">
              <span v-for="(item,index) in goodsInfo.duties" :key="index">{{item}}</span>
            </span>
          </div>
          <div class="infoItem">
            <span class="title">专家：</span>
            <span class="content">
              <div
                class="itemZj"
                v-for=" (item,index) in goodsInfo.courses"
                :key="index"
                :title="item.expert.real_name"
              >
                <el-image
                  style="width:40px;height:40px;border-radius:20px"
                  :src="item.expert.avatar"
                  fit="cover"
                ></el-image>
                <div class="ellipsis-1 usrename" style="margin-top:3px">{{item.expert.real_name}}</div>
              </div>
            </span>
          </div>
          <div class="infoItem">
            <span class="title">总金额：</span>
            {{totalPrice}}
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div style="margin-top:10px">
          <h3>班级课程：</h3>
          <el-tree
            default-expand-all
            v-if="activeTab==1"
            :data="goodsInfo.courses"
            :props="defaultProps"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="margin-top:10px">
          <h3>班级学员：</h3>
          <span class="content">
            <div
              class="itemZj studentBox"
              v-for=" (item,index) in stationUsers"
              :key="index"
              :title="item.user.name"
            >
              <el-image style="width:40px;height:40px;border-radius:20px" :src="item.user.avatar"></el-image>
              <div class="ellipsis-1 usrename" style="margin-top:3px">{{item.user.name}}</div>
            </div>
          </span>
        </div>
      </el-col>
    </el-row>

    <div class="buttonBox">
      <el-button type="danger" style="margin-right:20px" @click="sureOrder">立即报名</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showInfo: false,
      userIds: [],
      stationUsers: [],
      orderInfo: {},
      totalPrice: 0,
      keyword: "",
      classId: "",
      goodsInfo: {
        id: "", //班级id
        name: "", //班级名称
        thumb_image: "", //缩略图
        introduce: "", //课程介绍
        begin_at: "", //开始时间
        end_at: "", //结束时间
        score: "", //评分
        courses: [
          {
            id: "", //课程ID
            title: "", //课程标题
            expert: {
              id: "", //专家id
              real_name: "", //专家名称
              avatar: "", //专家头像
            },
          },
        ],
      },
      tableData: [],
      defaultProps: {
        children: "videos",
        label: "title",
      },
      activeTab: 1,
      activeName: "first",
    };
  },

  created() {
    if (this.$route.query && this.$route.query.id) {
      this.classId = this.$route.query.id;
      this.userIds = JSON.parse(this.$route.query.userIds);
      this.getClassDetail(this.$route.query.id);
      this.getClassPrice();
    } else {
      console.log(1);
    }
  },
  methods: {
    sureOrder() {
      this.$http({
        url: "/api/v1/auth/orders/station-submit",
        method: "POST",
        data: { station_user_ids: this.userIds, classes_id: this.classId },
      }).then((res) => {
        if (res.status == 200) {
          this.orderInfo = res.data.order;
          this.showInfo = true;
          this.$router.push({
            path: "/classOrderRes",
            query: {
              created_at: this.orderInfo.created_at,
              orderId: this.orderInfo.id,
              sn: this.orderInfo.sn,
              realy_price: this.orderInfo.realy_price,
            },
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getClassDetail(id) {
      this.$http({
        url: "/api/v1/classes/" + id,
        method: "get",
      })
        .then((res) => {
          if (res.status == 200) {
            this.goodsInfo = Object.assign(
              this.goodsInfo,
              {},
              res.data.classes
            );
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("系统错误");
        });
    },

    /**获取价格 */
    getClassPrice() {
      this.$http({
        url: "/api/v1/auth/orders/station-price",
        method: "POST",
        data: { station_user_ids: this.userIds, classes_id: this.classId },
      }).then((res) => {
        if (res.status == 200) {
          if (res.data && res.data.stationUsers) {
            this.stationUsers = res.data.stationUsers;
            this.totalPrice = res.data.total;
          } else {
            this.$alert(res.msg, "标题名称", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push("/userMessage");
              },
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleNodeClick(data) {
      console.log(data);
    },
  },
};
</script>

<style lang="less" scoped>
.goodsTit {
  color: rgba(80, 80, 80, 1);
  font-size: 20px;
  line-height: 1.5;
  text-align: left;
  font-weight: bold;
}
.dialogBox {
  display: flex;
  img {
    width: 172px;
    margin-top: 30px;
  }
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .tips {
    margin: 60px 0;
    height: 33px;
    opacity: 0.81;
    letter-spacing: 8px;
    color: rgba(0, 0, 0, 1);
    font-size: 22px;
    line-height: 33px;
  }
}
.courseDetail {
  margin-top: 10px;
  border: rgba(229, 229, 229, 1) solid 1px;
  .courseHead {
    height: 70px;
    border-bottom: rgba(229, 229, 229, 1) solid 1px;
    text-align: center;
    .tabItem {
      display: inline-block;
      margin: 0 80px;
      height: 70px;
      line-height: 70px;
      cursor: pointer;
      &.active {
        border-bottom: 4px solid #2a82e4;
        color: #2a82e4;
      }
    }
  }
  .courseContent {
    padding: 20px;
    min-height: 400px;
  }
}
.priceInfo {
  padding: 0;

  .infoItem {
    display: flex;
    align-items: center;
    margin: 10px 0;
    .title {
      width: 80px;
      font-weight: 500;
      color: #333;
      font-size: 16px;
      text-align: right;
    }
  }
}
.content {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .itemZj {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    height: 80px;
    width: 80px;
    cursor: pointer;
    text-align: center;
    .usrename {
      width: 100%;
    }
  }
}
.buttonBox {
  text-align: center;
  button {
    width: 186px;
  }
}
.premval {
  color: rgba(212, 48, 48, 1);
  font-size: 28px;
  line-height: 150%;
  text-align: center;
  font-weight: bold;
}
.oldPrice {
  color: #333;
  font-size: 20px;
  line-height: 48px;
  text-align: center;
  margin-left: 10px;

  text-decoration: line-through;
}
</style>